import { getConfig } from '@edx/frontend-platform';
import { logError } from '@edx/frontend-platform/logging';

import type { CourseCompletionResponse } from '../types';
import { apiRequest } from './utils/apiClient';

export const completionsApi = {
  getUserAllCourseCompletions: async (
    username: string,
    callback: (res: CourseCompletionResponse[]) => void,
    errorCallback?: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/users/completions/?username=${username}`;

    try {
      const data = await apiRequest<CourseCompletionResponse[]>({
        url,
        isAuth: true,
        method: 'GET',
      });

      callback(data);
    } catch (error) {
      logError('Error fetching user course completions', error);
      if (errorCallback) {
        errorCallback(error as Error);
      }
    }
  },
};
